module.exports = __webpack_public_path__ + "media/assets/svgs/instagram-6c3edcb7f50dce155bf225962f2f1514.svg";